<script>
    import { CustomTooltip } from "../../../Components/Common/index.svelte";

    import {
        goToURL,
        isFunctionEmpty,
    } from "../../../Utils/utilFunctions.svelte";

    import { getEncounterMissingProperties } from "../helpers/encounterHelper.svelte";

    export let row = {};
    export let clickable = false;
    export let clickFunc;
    export let viewID;

    $: encounterMissingProperties = getEncounterMissingProperties(row);

    const handleClickEncounterID = () => {
        if (!clickable) return;

        if (!clickFunc || isFunctionEmpty(clickFunc))
            goToURL(`/PatientEncounter/view/${viewID ? viewID : row.id}`);
        else clickFunc();
    };
</script>

<div class="flex flex-1 gap-x-1 items-center justify-start">
    <p
        class={`${clickable ? "text-secondary cursor-pointer hover:underline" : ""}`}
        on:click={handleClickEncounterID}
    >
        {row.id}
    </p>

    {#if encounterMissingProperties.length}
        <CustomTooltip contentClass="border-rose-600">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                class="stroke-error shrink-0 w-4 h-4"
                slot="tooltipTrigger"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
            </svg>

            <div class="flex flex-col items-start gap-y-1 cursor-default">
                {#each encounterMissingProperties as missingText}
                    <p class="text-error">{missingText}</p>
                {/each}
            </div>
        </CustomTooltip>
    {/if}
</div>
